let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("15JEv")).then(() => parcelRequire('4Wx0w'));